import { render, staticRenderFns } from "./PanelForm.vue?vue&type=template&id=f288e5f0"
import script from "./PanelForm.vue?vue&type=script&lang=js"
export * from "./PanelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports